// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Gallery_Wrapper__vP8hK","Container":"Gallery_Container__3VtG0"};